import { render, staticRenderFns } from "./AssignSops.vue?vue&type=template&id=506bba24&scoped=true&"
import script from "./AssignSops.vue?vue&type=script&lang=js&"
export * from "./AssignSops.vue?vue&type=script&lang=js&"
import style0 from "./AssignSops.vue?vue&type=style&index=0&id=506bba24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bba24",
  null
  
)

export default component.exports